<template>
  <el-alert
      type="error"
      effect="dark"
      ref="alertError"
      @close="close"
      v-if="value"
  >
    <template v-slot:title>
      <div class="alert-title" v-if="title">
        {{title}}
      </div>
    </template>
    <div
      v-html="description"
    />
  </el-alert>
</template>
<script>
export default {
  name: 'AlertaErro',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  methods: {
    close () {
      this.$emit('input', false)

      this.$refs.alertError.visible = true
    }
  }
}
</script>
